globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useCallback, useMemo } from 'react';
import * as turf from '@turf/turf';
import { defaultItalyCoordinates } from '../constants'; // Custom hook to calculate the bounding radius of a map view

export var useMapBoundingRadius = function useMapBoundingRadius(_ref) {
  var map = _ref.map;
  // Memoize the map center coordinates, fallback to default if unavailable
  var center = useMemo(function () {
    return map !== null && map !== void 0 && map.getCenter() ? [map.getCenter().lng, map.getCenter().lat] : defaultItalyCoordinates;
  }, [map]); // Get the northeast corner of the current map bounds

  var getBoundsCorner = useCallback(function () {
    var b = map === null || map === void 0 ? void 0 : map.getBounds();

    if (b) {
      // Get the northeast corner
      var ne = b.getNorthEast();
      return [ne.lng, ne.lat];
    }

    return null;
  }, [map]); // Calculate the radius from a given point to the bounds corner, doubled for full coverage

  var getRadius = useCallback(function (_ref2) {
    var lon = _ref2.lon,
        lat = _ref2.lat;
    var boundsCorner = getBoundsCorner();
    if (!boundsCorner) return; // Create turf points for distance calculation

    var from = turf.point([lon, lat]);
    var to = turf.point(boundsCorner);
    var options = {
      units: 'meters'
    }; // Calculate the distance between the center and the bounds corner

    var distance = turf.distance(from, to, options); // Ensure a minimum radius (e.g., 500 meters)

    return Math.max(distance * 2, 500);
  }, [getBoundsCorner]); // Return the radius calculation function and the map center

  return {
    getRadius: getRadius,
    center: center
  };
};